module.exports = __webpack_public_path__ + "img/buy.7614f56a.svg";